import Api from '@/api/baseApi'

export default {
    getList() {
        return Api.get('/vts/api/SOS/GetSosData');
    },
    updateList(data) {
        return Api.put(`/vts/api/SOS/AcknowledgeSOS`, data);
    },
    getSosCount() {
        return Api.get('/vts/api/SOS/GetSosCount');
    },
}